var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 1.99984C4.68564 1.99984 1.99935 4.68613 1.99935 7.99984V8.6665H0.666016V7.99984C0.666016 3.94975 3.94926 0.666504 7.99935 0.666504C10.4804 0.666504 12.6727 1.89853 13.9993 3.78263V1.33317H15.3327V5.99984H10.666V4.6665H12.9891C11.9123 3.0578 10.0788 1.99984 7.99935 1.99984Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3326 7.33317V7.99984C15.3326 12.0499 12.0494 15.3332 7.99931 15.3332C5.51829 15.3332 3.32603 14.1012 1.99935 12.2171V14.6665H0.666016V9.99984H5.33268V11.3332H3.00951C4.08635 12.9419 5.91981 13.9998 7.99931 13.9998C11.313 13.9998 13.9993 11.3135 13.9993 7.99984V7.33317H15.3326Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.75dd16f6a4a42cb6dcf5b4155ab3953f.svg";
export { ForwardRef as ReactComponent };